import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    Box,
    Grid,
    Grow,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    TableHead,
    TableRow,
    TableSortLabel,
    TextField,
    Button,
    TablePagination,
} from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import { useHistory } from "react-router-dom";
import SearchBar from "../../components/SearchBar/SearchBar";
import AddButton from "../../components/AddButton/AddButton";
import TableButtons from "../../components/Button/TableButtons";
import LoadingBackdrop from "../../components/LoadingBackdrop/LoadingBackdrop";
import Modal from "../../components/Modal/Modal";
import { useTranslation } from "react-i18next";
import { getUserList, updateRecord, deleteRecord, addRecord, getPlants } from "../../store/actions/userActions";
import { StyledTableDiv } from "../../components/StyledComponents/StyledComponents";
import makeStyles from "@mui/styles/makeStyles";
import { getTitle } from "../../common";
import { FcInfo } from "react-icons/fc";
import { getUserPlantList } from "../../store/actions/userActions";

const useStyles = makeStyles((theme) => ({
    helperText: {
        fontSize: "10px",
        width: "150px",
    },
}));

function UserNew() {
    const { t } = useTranslation("translation");
    const classes = useStyles();
    const dispatch = useDispatch();
    const [initialRows, setInitialRows] = useState([]);
    let [rows, setRows] = useState([]);
    const [rowsLength, setRowsLength] = useState(0);
    const [pageLoaded, setPageLoaded] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);
    const [noteDetails, setNoteDetails] = useState("");
    const [userPlants, setUserPlants] = useState([]);
    const [blankRowOpened, setBlankRowOpened] = useState(false);
    const [error, setError] = useState({
        userNameErrorText: t("UserNameShouldBeFilled"),
        userCodeErrorText: t("UserCodeShouldBeFilled"),
        plantCodeErrorText: t("PlantCodeShouldBeFilled"),
    });

    const { userRecords, plants, isTaskUpdatedUser, userPlantList } = useSelector(({ user }) => user);

    useEffect(() => {
        if (userPlantList?.resultObject) {
            // It should return true from Api
            const { resultObject } = userPlantList;
            setUserPlants(resultObject);
        }
    }, [userPlantList]);

    const renderTableCell = (rowItems, isSortingAction = true) => {
        var directionType = sortOrder === 0 ? "asc" : "desc";
        return rowItems.map((item, index) => {
            if (item.id === "Actions") {
                return (
                    <TableCell id={`user_rowItems_TableCell_Actions_${index}_${item.id}`} align="center">
                        {t("Actions")}
                    </TableCell>
                );
            } else {
                return isSortingAction ? (
                    <TableCell id={`user_rowItems_TableCell_${index}_${item.id}`} align="center" style={{ padding: 0 }}>
                        <TableSortLabel
                            id={`user_rowItems_TableSortLabel_${index}_${item.id}`}
                            active={sortColumn === item.id}
                            direction={directionType}
                            onClick={() => handleSort(sortOrder === 1 ? 0 : 1, item.id)}
                            style={{ paddingLeft: 25 }}
                        >
                            {item.label}
                        </TableSortLabel>
                    </TableCell>
                ) : (
                    <TableCell align="center">{item.label}</TableCell>
                );
            }
        });
    };

    const [addDisabled, setAddDisabled] = useState(false);
    useEffect(() => {
        if (error.userNameErrorText !== "" || error.userCodeErrorText !== "" || error.plantCodeErrorText !== "") {
            setAddDisabled(true);
        } else {
            setAddDisabled(false);
        }
    }, [error]);

    useEffect(() => {
        const oktaToken = JSON.parse(localStorage.getItem("okta-token-storage"));
            if (oktaToken && oktaToken.idToken) {
                const userCode = oktaToken.idToken.claims.preferred_username.replace("@arcelik.com", "");

                let payload = {
                    userCode: userCode,
                    fromUser: false,
                };
                dispatch(getUserPlantList(payload));
            }
        loadHandler();
    }, []);

    useEffect(() => {
        if (plants?.resultObject) {
            setPlantList(plants.resultObject);
        }
    }, [plants]);

    useEffect(() => {
        if (userRecords?.resultObject) {
            setPageLoaded(true);
            setRows(Object.values(userRecords.resultObject)[0].content);
            setInitialRows(cloneObject(Object.values(userRecords.resultObject)[0].content));
            setRowsLength(userRecords.resultObject.resultObject.totalCount);
            setEditableRow(false);
            setDisableButton(false);
        }
    }, [userRecords]);

    useEffect(() => {
        if (isTaskUpdatedUser) {
            
            loadHandler();
        }
    }, [isTaskUpdatedUser]);

    const loadHandler = (pageNumber = currentPage, pageSize = rowsPerPage) => {
        getPlantCodeHandler();
        var payload = {
            pageNumber: pageNumber + 1,
            pageSize: pageSize,
            data: {
                searchText: filterText,
                sortItem: {
                    propertyName: sortColumn,
                    direction: sortOrder,
                },
            },
        };
        dispatch(getUserList(payload));
    };

    //dynamic sort function
    let [sortOrder, setSortOrder] = useState(0);
    let [sortColumn, setSortColumn] = useState("");
    const handleSort = (order, column) => {
        setSortOrder(order);
        setSortColumn(column);
        var payload = {
            pageNumber: currentPage + 1,
            pageSize: rowsPerPage,
            data: {
                searchText: filterText,
                sortItem: {
                    propertyName: column,
                    direction: order,
                },
            },
        };
        dispatch(getUserList(payload));
    };

    //filter table
    const [filterText, setFilterText] = useState("");
    const filterData = (value) => {
        var payload = {
            pageNumber: currentPage,
            pageSize: rowsPerPage,
            data: {
                searchText: value,
                sortItem: {
                    propertyName: sortColumn,
                    direction: sortOrder,
                },
            },
        };
        dispatch(getUserList(payload));
    };

    //pagination
    const [currentPage, setCurrentPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(20);
    const handleChangePage = (_event, newPage) => {
        setCurrentPage(newPage);
        loadHandler(newPage, rowsPerPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setCurrentPage(0);
        loadHandler(0, event.target.value);
    };

    const cloneObject = (obj) => {
        return JSON.parse(JSON.stringify(obj));
    };

    //edit rows
    const [editable, setEditable] = useState(false);
    const [editableRow, setEditableRow] = useState("");
    const enableEditHandler = (row) => {
        setBlankRowOpened(false);
        setDisableButton(true);
        setRows(cloneObject(initialRows));
        setAddedPlantID(row.plantId);
        setEditableRow(row.id);
        setEditable(true);
        setError({
            userNameErrorText: "",
            userCodeErrorText: "",
            plantCodeErrorText: "",
        });
    };

    //enable disable add button
    const [disableButton, setDisableButton] = useState(false);
    const disableEditHandler = () => {
        const oldRows = cloneObject(initialRows);
        setRows(oldRows);
        setEditable(false);
        //enable edit button
        setDisableButton(false);
        setAddedPlantID(0);
        setError({
            userNameErrorText: t("UserNameShouldBeFilled"),
            userCodeErrorText: t("UserCodeShouldBeFilled"),
            plantCodeErrorText: t("PlantCodeShouldBeFilled"),
        });
    };

    //modal
    const [isModalOpen, setModalOpen] = useState(false);
    const [deletedRow, setDeletedRow] = useState([]);
    const deleteButtonHandler = (row) => {
        setDeletedRow(row);
        toggleModal();
    };

    const toggleModal = () => {
        setModalOpen((prevState) => !prevState);
    };

    //page redirect
    let history = useHistory();
    const openDetailPage = (id) => {
        history.push("addusertogroup?id=" + id);
    };

    //set edited rows
    const setRowHandler = (value, obj, updatedRow) => {
        const index = rows.indexOf(updatedRow);
        if (updatedRow.id !== "") {
            const row = rows[index];
            row[obj] = value;
            rows[index] = row;
            setRows(rows);
        } else {
            const row = rows[index];
            row[obj] = value;
            setRows(rows);
            if (value.length > 0) {
                if (obj !== "userName" && obj !== "userCode") {
                    setError({ ...error, plantCodeErrorText: "" });
                }
            } else {
                if (obj !== "userName" && obj !== "userCode") {
                    setError({ ...error, plantCodeErrorText: t("PlantCodeShouldBeFilled") });
                }
            }
        }
        if (value.length > 0) {
            if (obj === "userName") {
                setError({ ...error, userNameErrorText: "" });
            } else if (obj === "userCode") {
                setError({ ...error, userCodeErrorText: "" });
            }
        } else {
            if (obj === "userName") {
                setError({ ...error, userNameErrorText: t("UserNameShouldBeFilled") });
            } else if (obj === "userCode") {
                setError({ ...error, userCodeErrorText: t("UserCodeShouldBeFilled") });
            }
        }
    };

    //MAINTENANCE TEAM MEMBER
    const roleGroups = (roleGroups) => {
        var roleGroupsStr = "";
        roleGroups.forEach((element) => {
            roleGroupsStr += element.name + ",\n";
        });
        return roleGroupsStr;
    };
    //MECHANIC, AUTOMATIC
    const userGroups = (userGroups) => {
        var userGroupStr = "";
        userGroups.forEach((element) => {
            userGroupStr += element.groupName + ",\n";
        });
        return userGroupStr;
    };

    //get plant codes
    const [plantList, setPlantList] = useState([]);
    const getPlantCodeHandler = () => {
        dispatch(getPlants());
    };

    //set plantID
    let [addPlantID, setAddedPlantID] = useState(0);
    let [addPlantName, setAddedPlantName] = useState("");
    const newPlantID = (plantCode) => {
        if (plantCode != null) {
            setError({ ...error, plantCodeErrorText: "" });
            const filteredPlant = blankRowOpened ? plantList.filter((item) => item.code.includes(plantCode)) : userPlants.filter((item) => item.code.includes(plantCode));
            setAddedPlantID(filteredPlant[0].id);
            setAddedPlantName(filteredPlant[0].name);
            return [filteredPlant[0].id, filteredPlant[0].name];
        } else {
            setAddedPlantID(0);
            setAddedPlantName("");
            setError({ ...error, plantCodeErrorText: t("PlantCodeShouldBeFilled") });
        }
    };

    //update and add in one function
    const updateAddHandler = (row) => {
        //update
        if (row.id !== "") {
            let data = {
                id: row.id,
                userCode: row.userCode,
                userName: row.userName,
                department: row.department,
                plantId: addPlantID,
                status: 1,
            };
            dispatch(updateRecord(data));
        }
        //add
        else {
            //enable add button
            let data = {
                userCode: row.userCode,
                userName: row.userName,
                department: row.department,
                profilePictureUrl: "",
                plantId: addPlantID,
            };
            dispatch(addRecord(data));
            setError({ ...error, userCodeErrorText: t("UserCodeShouldBeFilled"), userNameErrorText: t("UserNameShouldBeFilled"), plantCodeErrorText: t("PlantCodeShouldBeFilled") });
            setAddedPlantID(0);
        }
    };

    //delete row
    const deleteHandler = (row) => {
        toggleModal();
        const deletePlantID = newPlantID(row.plantCode)[0];
        let data = {
            id: row.id,
            userCode: row.userCode,
            userName: row.userName,
            department: row.department,
            plantId: deletePlantID,
        };
        dispatch(deleteRecord(data));
    };

    //add blank row for new plant addition
    const addBlankRowHandler = () => {
        setBlankRowOpened(true);
        setError({ ...error, userCodeErrorText: t("UserCodeShouldBeFilled"), userNameErrorText: t("UserNameShouldBeFilled"), plantCodeErrorText: t("PlantCodeShouldBeFilled") });
        setAddedPlantID(0);
        setAddedPlantName("");
        setCurrentPage(0);
        //disable add button
        setDisableButton(true);
        let addedBlankRow = [
            {
                id: "",
                userCode: "",
                userName: "",
                department: "",
                roleGroup: "",
                userGroup: "",
                plantCode: "",
                plantName: "",
            },
        ];
        rows = addedBlankRow.concat(rows);
        setEditableRow(addedBlankRow[0].id);
        setEditable(true);
        setRows(rows);
    };

    const handleClose = () => {
        setOpenDialog(false);
    };

    const showNoteDetails = (row) => {
        if (!editable) {
            setOpenDialog(true);
            setNoteDetails(row);
        }
    };

    return (
        <StyledTableDiv>
            {getTitle(t("UserList"))}
            <AddButton onClick={() => addBlankRowHandler()} disabled={disableButton} />
            {pageLoaded === true ? (
                <React.Fragment>
                    <Grid container spacing={4} alignItems="center" justifyContent="center" sx={{ marginBottom: 4 }}>
                        <Grid item xs={12} sm={12} md={4}>
                            <SearchBar value={filterText} onChange={(newValue) => setFilterText(newValue)} onRequestSearch={(value) => filterData(value)} />
                        </Grid>
                    </Grid>
                </React.Fragment>
            ) : null}
            <Box m={2} />
            <Grow in={true} style={{ transformOrigin: "0 0 0" }} {...{ timeout: 1000 }}>
                <TableContainer id="user_TableContainer" component={Paper}>
                    <Table id="user_Table" aria-label="simple table">
                        <TableHead id="user_TableHead">
                            <TableRow id="user_TableRow">
                                {renderTableCell([
                                    { id: "id", label: t("ID") },
                                    { id: "userName", label: t("UserName") },
                                    { id: "userCode", label: t("UserRegistry") },
                                    { id: "department", label: t("UserDepartment") },
                                    { id: "roleGroup", label: t("RoleGroup") },
                                    { id: "userGroup", label: t("UserGroup") },
                                    { id: "plantCode", label: t("PlantCode") },
                                    { id: "plantName", label: t("PlantName") },
                                    { id: "Actions", label: t("Actions") },
                                ])}
                            </TableRow>
                        </TableHead>
                        <TableBody id="user_TableBody">
                            {rows.map((row, index) => (
                                <TableRow id={`user_TableRow_${index}`} key={row.id}>
                                    <TableCell id={`user_TableCell_${index}`} align="center">
                                        {row.id}
                                    </TableCell>
                                    <TableCell id={`user_TableCell_1_${index}`} align="center">
                                        {editable && editableRow === row.id ? (
                                            <TextField
                                                id={`user_TableCell_1_TextField_${index}`}
                                                onInput={(e) => setRowHandler(e.target.value, "userName", row)}
                                                defaultValue={row.userName}
                                                variant="outlined"
                                                FormHelperTextProps={{
                                                    className: classes.helperText,
                                                }}
                                                helperText={error.userNameErrorText}
                                                error={error.userNameErrorText.length === 0 ? false : true}
                                            />
                                        ) : (
                                            row.userName
                                        )}
                                    </TableCell>
                                    <TableCell id={`user_TableCell_2_${index}`} align="center">
                                        {editable && editableRow === row.id ? (
                                            <TextField
                                                id={`user_TableCell_2_TextField_${index}`}
                                                onInput={(e) => setRowHandler(e.target.value, "userCode", row)}
                                                defaultValue={row.userCode}
                                                variant="outlined"
                                                FormHelperTextProps={{
                                                    className: classes.helperText,
                                                }}
                                                helperText={error.userCodeErrorText}
                                                error={error.userCodeErrorText.length === 0 ? false : true}
                                            />
                                        ) : (
                                            row.userCode
                                        )}
                                    </TableCell>
                                    <TableCell id={`user_TableCell_3_${index}`} align="center">
                                        {editable && editableRow === row.id ? (
                                            <TextField
                                                id={`user_TableCell_3_TextField_${index}`}
                                                onInput={(e) => setRowHandler(e.target.value, "department", row)}
                                                defaultValue={row.department}
                                                variant="outlined"
                                            />
                                        ) : (
                                            row.department
                                        )}
                                    </TableCell>
                                    <TableCell id={`user_TableCell_4_${index}`} align="center">
                                        {editable && editableRow === row.id ? null : (
                                            <>
                                                {roleGroups(row.roleGroupsOfUser).length >= 20 ? roleGroups(row.roleGroupsOfUser).slice(0, 25) + "..." : roleGroups(row.roleGroupsOfUser)}
                                                {roleGroups(row.roleGroupsOfUser).length >= 20 ? <FcInfo onClick={() => showNoteDetails(roleGroups(row.roleGroupsOfUser))} /> : null}
                                            </>
                                        )}
                                    </TableCell>
                                    <TableCell id={`user_TableCell_5_${index}`} align="center">
                                        {editable && editableRow === row.id ? null : (
                                            <>
                                                {userGroups(row.groupsOfUser).length >= 20 ? userGroups(row.groupsOfUser).slice(0, 25) + "..." : userGroups(row.groupsOfUser)}
                                                {userGroups(row.groupsOfUser).length >= 20 ? <FcInfo onClick={() => showNoteDetails(userGroups(row.groupsOfUser))} /> : null}
                                            </>
                                        )}
                                    </TableCell>
                                    <TableCell id={`user_TableCell_6_${index}`} align="center">
                                        {editable && editableRow === row.id ? (
                                            <Autocomplete
                                                id={`user_TableCell_6_Autocomplete_${index}`}
                                                aria-required={true}
                                                defaultValue={row.plantCode}
                                                onChange={(event, newValue) => {
                                                    newPlantID(newValue);
                                                }}
                                                options={blankRowOpened ? plantList.map((option) => option.code) : userPlants.map((option) => option.code)}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        id={`user_TableCell_6_TextField_${index}`}
                                                        margin="normal"
                                                        variant="outlined"
                                                        FormHelperTextProps={{
                                                            className: classes.helperText,
                                                        }}
                                                        helperText={error.plantCodeErrorText}
                                                        error={row.plantId === 0 || row.plantId == null ? true : false}
                                                    />
                                                )}
                                            />
                                        ) : (
                                            row.plantCode
                                        )}
                                    </TableCell>
                                    <TableCell id={`user_TableCell_7_${index}`} align="center">
                                        {" "}
                                        {editable && editableRow === row.id ? addPlantName : row.plantName}
                                    </TableCell>
                                    <TableButtons
                                        addDisabled={addDisabled}
                                        editable={editable}
                                        editableRow={editableRow}
                                        row={row}
                                        updateAddHandler={() => updateAddHandler(row)}
                                        disableEditHandler={() => disableEditHandler()}
                                        enableEditHandler={() => enableEditHandler(row)}
                                        deleteButtonHandler={() => deleteButtonHandler(row)}
                                        openDetailPage={() => openDetailPage(row.id)}
                                        detail={true}
                                    />
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                    <TablePagination
                        id="user_TablePagination"
                        rowsPerPageOptions={[20, 50, 100]}
                        component="div"
                        count={rowsLength}
                        rowsPerPage={rowsPerPage}
                        page={currentPage}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </TableContainer>
            </Grow>
            <Dialog open={openDialog} onClose={handleClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
                <DialogTitle id="md_DialogTitle">{t("Information")}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="md_DialogDesc" style={{ overflow: "hidden", wordWrap: "break-word" }}>
                        {noteDetails}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} autoFocus>
                        OK
                    </Button>
                </DialogActions>
            </Dialog>
            <Modal title={t("Delete")} content={t("WillYouDoTransaction")} approved={() => deleteHandler(deletedRow)} isModalOpen={isModalOpen} toggle={toggleModal} />
            <LoadingBackdrop />
        </StyledTableDiv>
    );
}

export default UserNew;
